<template>
  <div class="layerPop" id="popEndorsement" v-if="isVisible">
    <div class="popWrap">
      <div class="popBox popType1">
        <div class="popHead">
          <p class="popTit">적하보험 일괄 출력</p>
        </div>
        <div class="popCon">
          <div class="conStyle1">
            <p class="tit mgt0 fcRed">적하보험 일괄출력시 유의사항</p>
          </div>
          <div class="boxNoti mgt30">
            <ul class="boxNoti_list">
              <li>1. 원본은 원본부수대로 출력됩니다.</li>
              <li>2. COPY 및 INVOICE는 기본 2장씩 출력됩니다.</li>
              <li>3. 배서번호에 상관없이 최종계약이 출력됩니다.</li>
              <li>4. 최대 출력건수는 30건 입니다.</li>
            </ul>
            <p class="boxNoti_text">
              <strong
                >출력건수에 따라 최대 3~5분 정도 소요되오니, 창을 닫지 마시고
                기다려 주시기 바랍니다.</strong
              >
            </p>
          </div>
          <div class="sortWrap typePrint mgt30">
            <dl>
              <dt class="fw700">원본</dt>
              <dd>
                <div class="inpCheck">
                  <input
                    type="checkbox"
                    id="except0"
                    v-model="state.ortxtCpno"
                  />
                  <label for="except0" class="fs14 fc66"></label>
                </div>
              </dd>
            </dl>
            <dl>
              <dt class="fw700">Invoice</dt>
              <dd>
                <div class="inpCheck">
                  <input
                    type="checkbox"
                    id="except1"
                    v-model="state.invoiceCheck"
                  />
                  <label for="except1" class="fs14 fc66"></label>
                </div>
              </dd>
            </dl>
            <dl>
              <dt class="fw700">복사여부</dt>
              <dd>
                <div class="inpCheck">
                  <input
                    type="checkbox"
                    id="except2"
                    v-model="state.copyCheck"
                  />
                  <label for="except2" class="fs14 fc66"></label>
                </div>
              </dd>
            </dl>
            <div class="btnWrap w100">
              <button
                type="button"
                class="btnType sizeS colorRL"
                @click="printTotal()"
              >
                <span>출력</span>
              </button>
            </div>
          </div>

          <div class="inpCheck mgt20">
            <input type="checkbox" id="except" v-model="state.hopPftOtptYn" />
            <label for="except" class="fs14 fc66">희망이익율 출력 제외</label>
          </div>
        </div>
        <div class="popBtn">
          <a class="btnType sizeS colorB" @click="close()"><span>취소</span></a>
        </div>
        <button
          type="button"
          class="popClose"
          onclick="popClose(this);"
          @click="close()"
        >
          <span class="hide">닫기</span>
        </button>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, defineEmits, reactive, inject, defineExpose } from "vue";
import * as codeList from "@/common/code";
import { sessionUserInfo, load } from "@/common/sessionFactory";
import encDownload from "@/common/encDownload.js";

const isVisible = ref(false);
const axios = inject("axios");

const swalAlert = inject("swalAlert");

let fnPolrResultdata = reactive({});
const state = reactive({
  ortxtCpnoList: [], //원본
  invoiceCntList: [], //invoice
  copyCntList: [], //복사
  ortxtCpno: "",
  invoiceCheck: "",
  copyCheck: "",
  ctrId: "",
  endrHisStdNo: "",
  endrNo: "0",
  polNo: "",
  totOrtxtCpno: "",
  Result: [],
  TotalParam: [{}],
  biz_no: "",
  invoiceCnt: "",
  copyCnt: "",
});

const emits = defineEmits(["update:data", "close"]);

//open시 데이터 받아오는 부분
const open = (d) => {
  state.biz_no = sessionUserInfo.userInfo.biz_no;
  fnPolrResultdata = d;
  isVisible.value = true;

  //초기화
  state.ortxtCpno = "";
  state.invoiceCheck = "";
  state.copyCheck = "";
};

const close = () => {
  isVisible.value = false;

  state.ortxtCpnoList = []; //원본
  state.invoiceCntList = []; //invoice
  state.copyCntList = []; //복사
  state.ctrId = "";
  state.endrHisStdNo = "";
  state.endrNo = "0";
  state.polNo = "";
  state.totOrtxtCpno = "";
  state.Result = [];
  state.TotalParam = [{}];
  fnPolrResultdata = {};

  emits("close");
};

//매수 선택시
// const onSelectEvent = (selectId, data) => {
//   console.log(data);
//   if (selectId == "ortxtCpno") {
//     state.ortxtCpno = data.code;
//   } else if (selectId == "invoiceCnt") {
//     state.invoiceCnt = data.code;
//   } else if (selectId == "copyCnt") {
//     state.copyCnt = data.code;
//   }
// };

const printTotal = async (reset) => {
  if (reset) {
    state.ortxtCpnoList = []; //원본
    state.invoiceCntList = []; //invoice
    state.copyCntList = []; //복사
    state.ctrId = "";
    state.endrHisStdNo = "";
    state.endrNo = "0";
    state.polNo = "";
    state.totOrtxtCpno = "";
    state.Result = [];
    state.TotalParam = [{}];
    fnPolrResultdata = {};
  }
  if (
    state.ortxtCpno == false &&
    state.invoiceCheck == false &&
    state.copyCheck == false
  ) {
    swalAlert("출력물을 선택 하세요.");
    return;
  }
  _.each(fnPolrResultdata, function (value) {
    state.ctrId += value.ctrId + "|";
    state.totOrtxtCpno += value.ortxtCpno + "|";
    state.polNo += value.polNo + "|";
  });

  // 원본 출력 선택 안하면 증권출력 대상 리스트 조회 시 조회 된 원본 부수 값을 각각 셋팅
  // 단, 한솔제지(1048658322) 일 경우 원본 2부 셋팅 (최대 30매 까지 가능하므로 array에 30개 이상을 2로 채워넣어 기간계에서 null point index 오류 방지)
  if (state.ortxtCpno) {
    if ("1048658322" == state.biz_no) {
      state.totOrtxtCpno +=
        "2|2|2|2|2|2|2|2|2|2|2|2|2|2|2|2|2|2|2|2|2|2|2|2|2|2|2|2|2|2|2|2|2|2|2|2|2|2|2|2|";
    }
  }
  // 인보이스 출력 선택 하면 기본 2매 출력
  // 단, 한솔제지(1048658322) 일 경우 원본 1부 셋팅
  if (state.invoiceCheck) {
    if ("1048658322" == state.biz_no) {
      state.invoiceCnt = "1";
    } else {
      state.invoiceCnt = "2";
    }
  }
  // 복사본 출력 선택 하면 기본 2매 출력
  // 단, 한솔제지(1048658322) 일 경우 원본 5부 셋팅
  if (state.copyCheck) {
    if ("1048658322" == state.biz_no) {
      state.copyCnt = "5";
    } else {
      state.copyCnt = "2";
    }
  }
  //일괄 출력시 보내줘야하는 데이터
  let param = {
    ctrId: state.ctrId, // 계약ID
    endrHisStdNo: state.endrHisStdNo, // 배서이력기준번호
    endrNo: state.endrNo, // 배서번호
    polNo: state.polNo, // 증권번호
    otptDiv: "", // 출력구분(증권:100804  , 인보이스:100805 , 배서승인서:100807 , 배서인보이스:100806)
    otptSh: "2", // 출력형태 (양식:1 , A4:2)
    polEndrOtptDiv: "3", // 증권배서출력구분(1:계약 2:배서 3:증권+송장)
    cpyOriNum: state.copyCheck ? state.copyCnt : "", // 복사여부
    bndlOrtxtCpno: state.ortxtCpno ? state.totOrtxtCpno : "", //일괄 원본부수
    invcNum: state.invoiceCheck ? state.invoiceCnt : "",
    hopPftOtptYn: state.hopPftOtptYn ? "N" : "Y", // 희망이익율 체크 기준으로 체크되면 "N", 안되면 "Y"
    otptDivCd: "TOT", // 일괄출력임을 구분하는 코드 (일괄출력 : TOT , 단건 출력 : null )
  };

  let Result = await axios.transaction("FNGCTGFO0175", param);
  //await axios.get("/download.do?addFileNm=" + Result.body.otptPth);
  swalAlert(
    "출력건수에 따라 최대 3~5분 정도 소요되오니, 창을 닫지 마시고 기다려 주시기 바랍니다."
  );
  _.startsWith(Result.body.otptPth, "/")
    ? true
    : (Result.body.otptPth = "/" + Result.body.otptPth);

  let sFile = splitFile(Result.body.otptPth);
  console.log("sFile");
  console.log(sFile);

  const encFilePath = await encDownload.encryptData(sFile.dirPath, true);
  const encFileName = await encDownload.encryptData(sFile.filename, true);

  await axios.download(
    "/downloadEnc.do?addFileNm=" + encFileName + "&addFilePath=" + encFilePath
  );

  // await axios.download("/download.do?addFileNm=" + sFile.filename + "&addFilePath=" + sFile.dirPath);

  //await axios.download("/download.do?addFileNm=" + Result.body.otptPth);
  axios.json("/logHisLdg.do", {
    memo: "일괄 출력",
    page: window.location.hash,
  });
};

function splitFile(path) {
  const filename = path.split("/").pop();
  const dirPath = path.substring(0, path.lastIndexOf("/")) + "/";
  return { filename, dirPath };
}

async function init() {
  await load();
  state.ortxtCpnoList = codeList.getPolCntCodeList;
  state.invoiceCntList = codeList.getInvoiceCntCodeList;
  state.copyCntList = codeList.getCopyCntCodeList;
}

init();

defineExpose({ open, close });
</script>
